<template>
  <section class="indicadores">
    <header class="indicadores__header">
      <div>
        <h2>
          <i class="icofont-chart-bar-graph"></i>
          Meus indicadores de qualidade
        </h2>

        <p>Resultados dos meus indicadores de qualidade</p>
      </div>

      <div class="segmentado">
        <button
          v-for="opcao in filtros"
          :key="opcao.value"
          type="button"
          :class="{ active: filtro === opcao.value }"
          @click="filtro = opcao.value"
        >
          {{ opcao.label }}
        </button>
      </div>
    </header>

    <div class="tabela-wrapper">
      <table>
        <thead>
          <tr>
            <th>Indicador</th>
            <th>Numerador</th>
            <th>Denominador</th>
            <th>Pontuação</th>
            <th>Classificação</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="indicador in indicadoresFiltrados" :key="indicador.id">
            <td>{{ indicador.nome || '-' }}</td>

            <td>
              <div class="valor-indicador">
                <button
                  v-if="possuiBotaoSigtap(indicador.id)"
                  type="button"
                  class="botao-sigtap"
                  title="Ver procedimentos do numerador e denominador"
                  :aria-label="`Ver procedimentos SIGTAP de ${indicador.nome}`"
                  @click="$emit('abrir-sigtap', indicador)"
                >
                  <span>{{ exibirValor(indicador.numerador) }}</span>
                </button>

                <span v-else>
                  {{ exibirValor(indicador.numerador) }}
                </span>
              </div>
            </td>

            <td>
              <div class="valor-indicador">
                <button
                  v-if="possuiBotaoSigtap(indicador.id)"
                  type="button"
                  class="botao-sigtap"
                  title="Ver procedimentos do numerador e denominador"
                  :aria-label="`Ver procedimentos SIGTAP de ${indicador.nome}`"
                  @click="$emit('abrir-sigtap', indicador)"
                >
                  <span>{{ exibirValor(indicador.denominador) }}</span>
                </button>

                <span v-else>
                  {{ exibirValor(indicador.denominador) }}
                </span>
              </div>
            </td>

            <td>
              <strong>{{ exibirValor(indicador.pontuacao) }}</strong>
            </td>

            <td>
              <span
                class="classificacao"
                :class="`classificacao--${normalizar(indicador.classificacao)}`"
              >
                {{ indicador.classificacao || '-' }}
              </span>
            </td>
          </tr>

          <tr v-if="indicadoresFiltrados.length === 0">
            <td colspan="5" class="tabela-vazia">
              Nenhum indicador encontrado.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import utils from '@/mixins/utils'

const CAMPOS_PADRAO = {
  numerador: 'numerador',
  denominador: 'denominador',
  resultado: 'resultado',
  classificacao: 'classificacao',
  nota: 'nota',
  peso: 'peso',
}

const CAMPOS_INDICADORES = {
  38: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
  39: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
  40: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
  41: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
  42: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
  43: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
  44: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
  45: {
    numerador: 'numerador_quad',
    denominador: 'denominador_quad',
    resultado: 'resultado_quad',
    classificacao: 'classificacao_quad',
    nota: 'nota_quad',
    peso: 'peso',
  },
}

export default {
  name: 'TabelaIndicadores',
  props: {
    registros: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {
      filtro: 'outros',

      filtros: [
        {
          label: 'Outros',
          value: 'outros',
        },
        {
          label: 'Ótimos',
          value: 'otimo',
        },
        {
          label: 'Todos',
          value: 'todos',
        },
      ],
    }
  },
  watch: {
    indicadores: {
      immediate: true,
      handler(indicadores) {
        this.$emit('atualizar-indicadores', indicadores)
      },
    },
  },
  computed: {
    indicadores() {
      return this.mapearIndicadores(this.registros)
    },

    indicadoresFiltrados() {
      if (this.filtro === 'todos') {
        return this.indicadores
      }

      if (this.filtro === 'otimo') {
        return this.indicadores.filter(
          (indicador) => this.normalizar(indicador.classificacao) === 'otimo'
        )
      }

      return this.indicadores.filter(
        (indicador) => this.normalizar(indicador.classificacao) !== 'otimo'
      )
    },
  },
  methods: {
    /**
     * Converte os registros da série histórica para a estrutura da tabela.
     *
     * @param {Array} registros
     * @returns {Array}
     */
    mapearIndicadores(registros) {
      if (!Array.isArray(registros)) {
        return []
      }

      return registros
        .map((registro) => this.mapearIndicador(registro))
        .filter((indicador) => indicador.id)
    },

    /**
     * Converte um registro da API para um indicador da tabela.
     *
     * @param {Object} registro
     * @returns {Object}
     */
    mapearIndicador(registro) {
      const indicadorId = Number(registro?.indicador || 0)
      const dados = this.parseObjectJson(registro?.dados)
      const campos = this.getCamposIndicador(indicadorId)

      const classificacao = String(dados?.[campos.classificacao] ?? '-')

      return {
        id: indicadorId,
        nome: String(registro?.ds_indicador || ''),
        numerador: dados?.[campos.numerador],
        denominador: dados?.[campos.denominador],
        pontuacao: dados?.[campos.resultado],
        classificacao,
        cor: this.getCorIndicador(classificacao),
        nota: dados?.[campos.nota],
        peso: dados?.[campos.peso],
        dados,
      }
    },

    /**
     * Obtém o mapeamento de campos utilizado pelo indicador.
     *
     * Todos os indicadores utilizam os campos definidos em
     * CAMPOS_PADRAO. Quando um indicador possui uma regra
     * específica, apenas os campos informados em
     * CAMPOS_INDICADORES substituem os valores padrão.
     *
     * @param {number|string} indicadorId
     * @returns {Object}
     */
    getCamposIndicador(indicadorId) {
      return {
        ...CAMPOS_PADRAO,
        ...(CAMPOS_INDICADORES[Number(indicadorId)] || {}),
      }
    },

    /**
     * Verifica se o indicador deve exibir o botão SIGTAP.
     *
     * @param {number|string} indicadorId
     * @returns {boolean}
     */
    possuiBotaoSigtap(indicadorId) {
      return [39, 40, 41].includes(Number(indicadorId))
    },

    /**
     * Retorna um valor válido para exibição na tabela.
     *
     * Preserva valores numéricos iguais a zero.
     *
     * @param {*} valor
     * @returns {*}
     */
    exibirValor(valor) {
      if (valor === null || valor === undefined || valor === '') {
        return '-'
      }

      return valor
    },

    /**
     * Normaliza um texto para comparação e uso em classes CSS.
     *
     * @param {*} valor
     * @returns {string}
     */
    normalizar(valor) {
      return String(valor || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
    },

    /**
     * Retorna a cor correspondente à classificação.
     *
     * @param {string} classificacao
     * @returns {string}
     */
    getCorIndicador(classificacao) {
      switch (this.normalizar(classificacao)) {
        case 'otimo':
          return 'otima'

        case 'bom':
          return 'boa'

        case 'suficiente':
          return 'suficiente'

        default:
          return 'regular'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.indicadores {
  padding-top: 2.5rem;
  margin-top: 2.5rem;
  border-top: 1px solid #dbe1e8;

  &__header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.2rem;

    h2 {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin: 0;
      font-size: 1.25rem;
    }

    p {
      margin: 0.35rem 0 0;
      color: #64748b;
      font-size: 0.85rem;
    }
  }
}

.segmentado {
  display: inline-flex;
  padding: 0.25rem;
  background: #e5e7eb;
  border-radius: 0.55rem;

  button {
    min-width: 85px;
    padding: 0.5rem 0.9rem;
    color: #6b7280;
    font-size: 0.78rem;
    font-weight: 700;
    background: transparent;
    border: 0;
    border-radius: 0.4rem;
    transition: 0.2s;

    &.active {
      color: #111827;
      background: #fff;
      box-shadow: 0 1px 4px rgba(15, 23, 42, 0.15);
    }
  }
}

.tabela-wrapper {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th {
    padding: 0.9rem 1rem;
    color: #64748b;
    font-size: 0.7rem;
    text-align: center;
    text-transform: uppercase;
    background: #f8fafc;
  }

  th:first-child,
  td:first-child {
    text-align: left;
  }

  td {
    padding: 0.9rem 1rem;
    color: #4b5563;
    font-size: 0.84rem;
    text-align: center;
    border-top: 1px solid #f1f5f9;
  }

  tbody tr:hover {
    background: #f8fafc;
  }
}

.valor-indicador {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
}

.botao-sigtap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;

  min-height: 28px;
  padding: 0.2rem 0.55rem;

  color: #2e70d9;
  font-size: inherit;
  font-weight: 600;
  line-height: 1;

  background: rgba(46, 112, 217, 0.08);
  border: 0;
  border-radius: 999px;

  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

  span {
    color: inherit;
    line-height: 1;
  }

  i {
    flex-shrink: 0;
    font-size: 0.9rem;
  }

  &:hover {
    color: #fff;
    background: #2e70d9;
    transform: translateY(-1px);
  }

  &:focus {
    outline: 0;
    box-shadow: 0 0 0 3px rgba(46, 112, 217, 0.15);
  }
}

.classificacao {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.65rem;
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 999px;

  &--regular {
    color: #c46500;
    background: rgba(196, 101, 0, 0.12);
  }

  &--suficiente {
    color: #d5ba0a;
    background: rgba(213, 186, 10, 0.12);
  }

  &--bom {
    color: #38ba38;
    background: rgba(56, 186, 56, 0.12);
  }

  &--otimo {
    color: #1212b6;
    background: rgba(18, 18, 182, 0.12);
  }
}

.tabela-vazia {
  padding: 2rem !important;
  color: #64748b !important;
  text-align: center !important;
}

@media (max-width: 768px) {
  .indicadores__header {
    align-items: stretch;
    flex-direction: column;
  }

  .segmentado {
    width: 100%;

    button {
      flex: 1;
      min-width: 0;
    }
  }
}
</style>
